<template>
    <div class="city-cascader">
        <Popup :value="value" position="bottom" :overlay="true" @click-overlay="$emit('input', false)">
            <Area @cancel="$emit('cancel')"  @confirm="confirm" :area-list="options" :columns-num="level" :title="title" :value="defCity" />
        </Popup>
    </div>
</template>

<script>
    import { Popup,Area } from 'vant';
    import {listDistricts} from '@/api/components.js'

    export default {
        name: 'CityCascader',
        props: {
            show: Boolean,
            value: Boolean,
            defCity: {
                type: String,
                default: '110000'
            },
            level:{
                type: Number,
                default: 3
            },
            title: {
                type: String,
                defualt: "选择省市区"
            }
        },
        data:function () {
            return {
                options: {
                    province_list:{},
                    city_list:{},
                    county_list:{}
                },
            }
        },
        created(){
            listDistricts({parentCode:0}).then(r=>{
                this.setOption(r);
            }).catch(_=>{})
        },
        methods:{
            confirm(val){
                // 将省去除 '0000', 市 '00'
                let pro = {name: val[0].name, code: val[0].code.substr(0, 2)};
                let areaList = [];
                if(this.level === 1) {
                    areaList = [pro];
                } else if (this.level === 2) {
                    let city = {name: val[1].name, code: val[1].code.substr(0, 4)};
                    areaList = [pro, city];
                } else if (this.level === 3) {
                    let city = { name: val[1].name, code: val[1].code.substr(0, 4) };
                    areaList = [pro, city, val[2]];
                }
                this.$emit('changeCity',areaList);
            },
            setOption(data){
                data.forEach(p=>{
                    this.options.province_list[p.code + '0000'] = p.name;
                    p.children.forEach(c=>{
                        this.options.city_list[c.code + '00'] = c.name;
                        c.children.forEach(county=>{
                            this.options.county_list[county.code] = county.name;
                        })
                    })

                })

            }
        },
        components:{Popup,Area}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    .city-cascader{
        .van-picker__confirm,.van-picker__cancel{
            color: #F84025;
        }
        .van-picker__title{
            font-size: 15px;
            color: #222;
        }
    }
</style>

